<template>
  <div id="app">
    <router-view/>
    <BrandFooter/>
    <one-doc-spa/>
  </div>
</template>
<script>
import OneDocSpa from './components/OneDocSpa.vue'
export default {
  components: { OneDocSpa },
  mounted: function () {
    const externalScript = document.createElement('script')
    const recaptchaSiteKey = this.$store.state.recaptchaSiteKey
    externalScript.setAttribute('src', 'https://www.google.com/recaptcha/enterprise.js?render=' + recaptchaSiteKey)
    document.head.appendChild(externalScript)
  }
}
</script>
<style>
@import "assets/css/footer.css";
</style>
